import { Box, Stack } from '@mui/material'
import Input from 'components/shared/textFields/Input'
import { ICheckupList, IExaminersTrim } from 'models'
import { Moment } from 'moment'
import { Dispatch, SetStateAction, useState } from 'react'
import { CardStandart } from 'ui/CardStandart'
import DatePicker from 'ui/DatePickerInput/DatePicker'
import { DateRestriction } from 'ui/DatePickerInput/types'

import SwitchiOS from 'ui/SwitchiOS'
import { TypographyHeaderSecondary } from 'ui/typography/TypographyHeaderSecondary'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary14Bold } from 'ui/typography/TypographyPrimary14Bold'

type TrimBlockProps = {
	trim: IExaminersTrim
	setCheckupInfo: Dispatch<SetStateAction<ICheckupList>>
}

const TrimBlock = (props: TrimBlockProps) => {
	const { trim, setCheckupInfo } = props
	const [selectDate, setSelectedDate] = useState<number>(trim.target_date)
	const clickDatePicker = (date: Moment | null) => {
		if (!date) return
		const timestamp = date.valueOf()
		setSelectedDate(timestamp)
		setCheckupInfo(prev => {
			return {
				...prev,
				trim: {
					...prev.trim,
					target_date: timestamp,
				},
			}
		})
	}
	const onChangeComment = e => {
		const comment = e.target.value
		setCheckupInfo(prev => {
			return {
				...prev,
				trim: {
					...prev.trim,
					comment: comment,
				},
			}
		})
	}
	const toggleSwitch = () => {
		setCheckupInfo(prev => {
			return {
				...prev,
				trim: {
					...prev.trim,
					isTrim: !prev.trim.isTrim,
				},
			}
		})
	}
	return (
		<CardStandart sx={{ padding: '24px' }}>
			<Stack direction='column' gap='24px'>
				<TypographyHeaderSecondary>Обрезка копыт</TypographyHeaderSecondary>
				<Box display='flex' flexDirection='row' alignItems='center' gap='12px'>
					<TypographyPrimary14Bold>
						Проведена функциональная обрезка всех копыт
					</TypographyPrimary14Bold>
					<SwitchiOS
						checked={trim.isTrim}
						background='#65C466'
						onClick={toggleSwitch}
					/>
				</Box>
				<Box width='50%'>
					<Input
						value={trim.comment}
						onChange={e => onChangeComment(e)}
						isMultiline={true}
						label={'Комментарий'}
						width={'100%'}
						height={'100px'}
						rows={3}
						maxLength={140}
						isDisable={!trim.isTrim}
					/>
				</Box>
				<Box display='flex' flexDirection='row' alignItems='center' gap='16px'>
					<TypographyPrimary>Дата ближайшей обрезки:</TypographyPrimary>
					<DatePicker
						value={selectDate}
						onChange={newDate => clickDatePicker(newDate)}
						restrictionType={DateRestriction.FUTURE}
					/>
				</Box>
			</Stack>
		</CardStandart>
	)
}

export default TrimBlock
